import { render, staticRenderFns } from "./SupportItemsComponent.vue?vue&type=template&id=5b4061f7&scoped=true&"
import script from "./SupportItemsComponent.vue?vue&type=script&lang=js&"
export * from "./SupportItemsComponent.vue?vue&type=script&lang=js&"
import style0 from "./SupportItemsComponent.vue?vue&type=style&index=0&id=5b4061f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4061f7",
  null
  
)

export default component.exports